import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';
@Component({
  selector: 'lib-constant-edit',
  templateUrl: './constant-edit.component.html',
  styleUrls: ['./constant-edit.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class ConstantEditComponent implements OnInit {

  @ViewChild('footer') footer: TemplateRef<any>;

  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<string>();
  @Input()
  value: string;

  constructor(
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) { }

  ngOnInit() {
  }

  clickOK() {
    this.submitEmitter.emit(this.value);
  }

  clickCancel() {
    this.closeEmitter.emit();
  }
}
